import { render, staticRenderFns } from "./DialogStatusProduto.vue?vue&type=template&id=199fc488&scoped=true"
import script from "./DialogStatusProduto.vue?vue&type=script&lang=js"
export * from "./DialogStatusProduto.vue?vue&type=script&lang=js"
import style0 from "./DialogStatusProduto.vue?vue&type=style&index=0&id=199fc488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199fc488",
  null
  
)

export default component.exports